

















































































































































import { DATE_FORMAT_JA } from "@/common/constant";
import qNotify from "@/common/qNotify";
import PropertyUpdate from "@/components/property/propertyUpdateComponent.vue";
import Property from "@/model/property";
import moment from "moment";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import store from "@/store";
@Component({
  name: "PropertyDetail",
})
export default class PropertyDetail extends PropertyUpdate {
  public propertyObjectClone = new Property();

  @Watch("propertyObject")
  onChangeProperty(newValue) {
    if (newValue.id) {
      this.propertyObjectClone = new Property(this.propertyObject);
    }
  }

  get companyOfPersonInCharged() {
    return this.propertyObject.owner_company
      ? this.propertyObject.owner_company.name
      : "";
  }

  get contructionDate() {
    return moment(this.propertyObject.date_of_construction).format(
      DATE_FORMAT_JA
    );
  }

  get isChanged() {
    return (
      this.propertyObject.company_id !== this.propertyObjectClone.company_id ||
      this.propertyObject.person_in_charge_id !==
        this.propertyObjectClone.person_in_charge_id
    );
  }

  public async update() {
    if (this.isChanged) {
      const result = await this.propertyObjectClone.updateCompany();

      if (result.meta.status != 200) {
        qNotify.error({
          text: this.$t(result.meta.message),
        });
        this.errors = result.meta.errors;
      } else {
        qNotify.success({
          text: this.$t("properties.updated"),
        });
        this.$router.push({ name: "admin.property", query: store.state.Router.getSearchParameters ? store.state.Router.getSearchParameters.propertyList : null});
      }
    } else {
      qNotify.error({
        text: this.$t("not_changed"),
      });
    }
  }

  public cancel() {
    if (this.isChanged) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.property" , query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.push({ name: "admin.property" , query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
    }
  }
}
